import { User } from "oidc-client-ts";
import { useUserManager } from "../context/UserManagerContext";
import { Dispatch, SetStateAction } from "react";

export default function Logout(setUser: Dispatch<SetStateAction<User | null>>) {
  const { userManager } = useUserManager();

  const handleManualLogout = () => {
    userManager.signoutRedirect().then(() => {
      const embed: any = document.getElementById("theEmbed");
      if (embed) embed.logout();
      setUser(null);
    });
  };

  const handleAutomaticLogout = async (user: User | null) => {
    if (!user) return;

    try {
      setUser(null);

      const embed: any = document.getElementById("theEmbed");
      if (embed) embed.logout();

      await userManager.removeUser();
      await userManager.signoutRedirect();
    } catch (error) {
      console.error("Automatic logout failed when timeout", error);
      window.location.href = "/?logout=true";
    }
  };

  return { handleManualLogout, handleAutomaticLogout };
}